import { PublicApiClient } from '@guiker/booking-shared'
import { AuthenticatedApiClient } from '@guiker/listing-inquiry-shared'
import { useAuthenticatedApiClient, usePublicApiClient } from '@guiker/react-framework'

export const useAuthenticatedListingInquiryApiClient = useAuthenticatedApiClient(AuthenticatedApiClient)
export const usePublicBookingApiClient = usePublicApiClient(PublicApiClient)
